module.exports = __webpack_public_path__ + "static/img/qingjia.3c83b919.png";